
<sabis-ngx-dialog scTitle="Feedback Request Users">

  <div modal-body class="feedback-request__modal-content">
    @if (isLoading ) {
      <div>Loading...Please Wait</div>
    }

    @if (!isLoading && feedbackRequestInfo && canView) {
      <mat-stepper orientation="vertical" #stepper>
        <mat-step>
          <ng-template matStepLabel>{{ userEmail }}</ng-template>
          <ng-template matStepContent>
          <sabis-dynamicform #formEditor
            [scId]="1"
            [scTemplate]="formInstanceInitData"
          [scValues]="feedbackFormValues"></sabis-dynamicform>
          </ng-template>
        </mat-step>
      </mat-stepper>
    }
    @if (!isLoading  && !canView) {
      <div>
        You do not have the needed access right. Please reach out to your Regional HR Manager.
      </div>
    }
  </div>
  <div modal-footer>

    @if (!isLoading && canView) {
      <sabis-ngx-button (click)="onDeleteRequestClick()">
        Delete Request
      </sabis-ngx-button>
    }

    @if (!isLoading && !isFeedbackAnswered && !isFeedbackCanceled && canView) {
      <sabis-ngx-button (click)="onCancelRequestClick()">
        Cancel Request
      </sabis-ngx-button>
    }

    @if (!isLoading && canView && canLockFeedbackForm) {
      <sabis-ngx-button (click)="onPermissionsClick()">
        Permissions
      </sabis-ngx-button>
    }

    @if (canView && !isLoading) {
      <sabis-ngx-button (click)="onPrintClick()">
        Print
      </sabis-ngx-button>
    }

    <sabis-ngx-button (click)="onCloseClick()">
      Close
    </sabis-ngx-button>
  </div>

</sabis-ngx-dialog>


